<div class="container">
  <div class="card">
    <div class="task-head">
      <h4>{{'Warning!'}}</h4>
    </div>

    <p *ngIf="data.type !== 'orderedWarning'">
      {{data.message}}
    </p>
    <p *ngIf="data.type === 'orderedWarning'" class="ordered-warning" [innerHTML]="data.message"></p>
  </div>

  <div class="btns" *ngIf="data.type !== 'abortApi'">
    <button
      class="custom-button"
      *ngIf="data.showCancelButton"
      (click)="cancel()"
    >{{ data.cancelButtonLabel || 'Cancel' }}</button>
    <button mat-flat-button (click)="onNoClick(1)">{{ data.buttonLabel || 'Continue' }}</button>
  </div>
   <div class="btns" *ngIf="data.type === 'abortApi'">
    <button class="custom-button" (click)="cancel()">Cancel</button>
    <button mat-flat-button (click)="confirm()">Confirm </button>
  </div>
</div>